import * as $ from 'jquery';
import 'jquery-datetimepicker/build/jquery.datetimepicker.full.min.js';
import 'jquery-datetimepicker/build/jquery.datetimepicker.min.css';

export default (function () {
  
  $.datetimepicker.setLocale('en');

  $('.date-time').datetimepicker({
    formatTime:'H:i',
    format:'Y-m-d H:i'
  }).attr('autocomplete', "off");

  $('.date').datetimepicker({
    timepicker:false,
    format:'Y-m-d'
  }).attr('autocomplete', "off");
  
  $('.time').datetimepicker({
      datepicker:false,
      formatTime:'H:i'
  }).attr('autocomplete', "off");

}
())
